import { render, staticRenderFns } from "./RecoltesMainView.vue?vue&type=template&id=276202f2"
import script from "./RecoltesMainView.vue?vue&type=script&lang=js"
export * from "./RecoltesMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports